import classes from './NameCell.module.css'
import classesCell from './BodyCell.module.css'

import { useDispatch, useSelector } from 'react-redux'
import { workqueueActions } from '../../../store/workqueue'
import { formatDateLocal } from '../../../lib/script'

import PatientOrChart from '../../patient/page/PatientOrChart'
import PhoneBox from './PhoneBox'
import { NGvsCaseid } from '../../../layout/NGvsCaseid'
import Tag from '../../fragments/Tag'
import { useWorkQShell, WorkQHoverHint } from '../context/workQShellContext'
import WorkQDeferredTooltip from './WorkQDeferredTooltip'

export default function NameCell({text, group, item, slug, hideDrawer, hasphone}) {
    const shell = useWorkQShell()
    const dispatch = useDispatch()
    const activeDrawer = useSelector(state => state.workqueue.activeDrawer)
    const lastActiveCase = useSelector(state => state.workqueue.lastActiveCase)

    const phone1 = item?.patient?.phone
    const phone2 = item?.patient?.contact_information?.phone
    const hasAnyPhone =
        (typeof phone1 === 'string' ? phone1.trim() : phone1) ||
        (typeof phone2 === 'string' ? phone2.trim() : phone2)

    function dropExpandHandler() {
        dispatch(workqueueActions.setOpenedDrawer(item?.case.id))   
        dispatch(workqueueActions.setLastActiveCase(item?.case.id))
    }

    // let showMinorWorkQ = slug == 'global-discharge-q'

    return <div className={classes.wrapper}>
        <div className={`${classes.name_cell} ${classesCell.body_cell} ${activeDrawer && item?.case?.id == activeDrawer ? classes.drawer_opened : ''} ${item?.case?.master_status_id == 0 ? classes.item_archived : ''} ${lastActiveCase && item?.case?.id == lastActiveCase ? classes.last_active_case : ''}`} > 
            <PatientOrChart item={item} color={'var(--white)'}/>
            {shell ? (
                <WorkQHoverHint
                    message={
                        <span
                            dangerouslySetInnerHTML={{
                                __html: `<strong>DOB: </strong> ${group?.dob ? formatDateLocal(group.dob) : "unknown"}`,
                            }}
                        />
                    }
                    className={classes.tooltip_wrapper}
                >
                    <NGvsCaseid item={item} slug={slug} caseid={item?.case.id} person_number={item?.patient.person_number}>{text ? text : '-'}</NGvsCaseid>
                    {group?.is_minor  ? <Tag color='RedSolid'>Minor</Tag> : ''}
                    {group?.is_disabled  ? <Tag color='RedSolid'>Disabled</Tag> : ''}
                    {!hideDrawer && <button onClick={dropExpandHandler} className={classes.expand_button}><i className='ti ti-chevron-down'></i></button>}
                </WorkQHoverHint>
            ) : (
            <WorkQDeferredTooltip
                normalEvent={true}
                messages={[`<strong>DOB: </strong> ${group?.dob ? formatDateLocal(group.dob) : 'unknown'}`]}
                wrapperClassName={classes.tooltip_wrapper}
            >
                <NGvsCaseid item={item} slug={slug} caseid={item?.case.id} person_number={item?.patient.person_number}>{text ? text : '-'}</NGvsCaseid>
                {group?.is_minor  ? <Tag color='RedSolid'>Minor</Tag> : ''}
                {group?.is_disabled  ? <Tag color='RedSolid'>Disabled</Tag> : ''}
                {!hideDrawer && <button onClick={dropExpandHandler} className={classes.expand_button}><i className='ti ti-chevron-down'></i></button>}
            </WorkQDeferredTooltip>
            )}
            {hasphone && hasAnyPhone && <div className={classes.phone_cell}>
                {(typeof phone1 === 'string' ? phone1.trim() : phone1) && <PhoneBox data={phone1}/>}
                {(typeof phone2 === 'string' ? phone2.trim() : phone2) && <PhoneBox data={phone2}/>}
            </div>}
        </div>
    </div>
}